import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/baseDataZXXBMIXS/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/baseDataZXXBMIXS/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/baseDataZXXBMIXS/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/baseDataZXXBMIXS/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/baseDataZXXBMIXS/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/baseDataZXXBMIXS/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/baseDataZXXBMIXS/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/baseDataZXXBMIXS/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/baseDataZXXBMIXS/update/batch',
    method: 'POST',
    data})
}

   